import { getLoans, GetLoansReturn } from 'graphql/loans/queries';
import { UseQueryOptions, useQuery } from 'react-query';
import { orderAccountingLoanEntriesByDescription } from 'utils/accounting';

type Params = {
  orderId: string;
  queryConfig?: UseQueryOptions<GetLoansReturn, Error, GetLoansReturn, any>;
};

export const useGetLoans = ({ orderId, queryConfig }: Params) =>
  useQuery(
    ['loans', orderId],
    async () => {
      const response = await getLoans({ orderId });

      return {
        ...response,
        getOrder: {
          ...response.getOrder,
          loans: response.getOrder.loans.map((loan) => ({
            ...loan,
            accounting: orderAccountingLoanEntriesByDescription(loan.accounting),
          })),
        },
      };
    },
    {
      ...queryConfig,
      enabled: !!orderId && queryConfig?.enabled !== false,
      refetchOnWindowFocus: false,
    }
  );
